/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import axios_http from 'axios';
import VueAxios from '../axios';
import auth from './auth';

Vue.use(VueAxios);
Vue.use(Vuex);
const axios = axios_http;
const rtmKlikDomain = 'https://rtm.glueapi.io/v3';
const store = new Vuex.Store({
  state: {
    masthead_featured: [], //rtm
    news_masthead_featured: [],
    tv_list: [],
    tv_fast_channel_list: [],
    popular_list: [],
    drama_list: [],
    telefilem_list: [],
    berita_list: [],
    hiburan_list: [],
    vod_masthead_list: [],
    ekslusif_list: [],
    saluran_khas: [],
    bes_plus_list: [],
  },
  mutations: {
    // v1
    FETCH_TV_FASTCHANNEL_LIST(state, tv_fast_channel_list) {
      state.tv_fast_channel_list = tv_fast_channel_list;
    },
    FETCH_SALURANKHASLIST(state, saluran_khas) {
      state.saluran_khas = saluran_khas;
    },
    FETCH_EKSKLUSIFLIST(state, ekslusif_list) {
      state.ekslusif_list = ekslusif_list;
    },
    FETCH_MASTHEAD_FEATURED(state, masthead_featured) {
      state.masthead_featured = masthead_featured;
    },
    FETCH_NEWS_MASTHEAD_FEATURED(state, news_masthead_featured) {
      state.news_masthead_featured = news_masthead_featured;
    },
    FETCH_TVLIST(state, tv_list) {
      state.tv_list = tv_list;
    },
    FETCH_POPULARLIST(state, popular_list) {
      state.popular_list = popular_list;
    },
    FETCH_DRAMALIST(state, drama_list) {
      state.drama_list = drama_list;
    },
    FETCH_TELEFILEMLIST(state, telefilem_list) {
      state.telefilem_list = telefilem_list;
    },
    FETCH_BERITALIST(state, berita_list) {
      state.berita_list = berita_list;
    },
    FETCH_HIBURANLIST(state, hiburan_list) {
      state.hiburan_list = hiburan_list;
    },
    FETCH_VODMASTHEADLIST(state, vod_masthead_list) {
      state.vod_masthead_list = vod_masthead_list;
    },
    FETCH_BESPLUSLIST(state, bes_plus_list) {
      state.bes_plus_list = bes_plus_list;
    },
  },
  actions: {
    // rtm
    fetchBesPlusList({ commit }, { self }) {
      try {
        axios
          .get(
            `${rtmKlikDomain}/content?idSchemas=2012&sort=dateAvailability&idApp=1`
          )
          .then(function(response) {
            self.bes_plus_list = response.data;
            commit('FETCH_BESPLUSLIST', self.bes_plus_list);

            self.filterBesPlusList();
          });
      } catch (e) {
        console.log(e);
      }
    },
    fetchSaluranKhasList({ commit }, { self }) {
      try {
        axios
          .get(
            `${rtmKlikDomain}/content?idSchemas=2012&sort=dateAvailability&idApp=1`
          )
          .then(function(response) {
            self.saluran_khas = response.data;
            commit('FETCH_SALURANKHASLIST', self.saluran_khas);

            self.filterSaluranKhasList();
          });
      } catch (e) {
        console.log(e);
      }
    },
    fetchEksklusifList({ commit }, { self }) {
      try {
        axios
          .get(
            `${rtmKlikDomain}/content?fieldPath=categories&idSchemas=2003,2004,2005,2007,2009&fieldValue=1020&sort=-dateAvailability&idApp=1`
          )
          .then(function(response) {
            self.ekslusif_list = response.data;
            commit('FETCH_EKSKLUSIFLIST', self.ekslusif_list);

            self.filterEkslusifList();
          });
      } catch (e) {
        console.log(e);
      }
    },
    fetchVODMastheadList({ commit }, { self }) {
      try {
        axios
          .get(
            `${rtmKlikDomain}/content?idSchemas=2005&isFeatured=1&sort=-dateFeature&fields=title,slug,data&idApp=1`
          )
          .then(function(response) {
            self.vod_masthead_list = response.data;
            commit('FETCH_VODMASTHEADLIST', self.vod_masthead_list);

            self.filterVODMastheadList();
          });
      } catch (e) {
        console.log(e);
      }
    },
    fetchHiburanList({ commit }, { self }) {
      try {
        axios
          .get(
            `${rtmKlikDomain}/content?fieldPath=categories&idSchemas=2003,2004,2005,2007,2009&sort=-dateAvailability&fieldValue=492&idApp=1`
          )
          .then(function(response) {
            self.hiburan_list = response.data;
            commit('FETCH_HIBURANLIST', self.hiburan_list);

            self.filterHiburanList();
          });
      } catch (e) {
        console.log(e);
      }
    },
    fetchBeritaList({ commit }, { self }) {
      try {
        axios
          .get(
            `${rtmKlikDomain}/content?idSchema=2007&sort=-dateAvailability&idApp=1`
          )
          .then(function(response) {
            self.berita_list = response.data;
            commit('FETCH_BERITALIST', self.berita_list);

            self.filterBeritaList();
          });
      } catch (e) {
        console.log(e);
      }
    },
    fetchDramaList({ commit }, { self }) {
      try {
        axios
          .get(
            `${rtmKlikDomain}/content?idSchemas=2005&fieldPath=categories&fieldValue=335&sort=-dateAvailability&idApp=1`
          )
          .then(function(response) {
            self.drama_list = response.data;
            commit('FETCH_DRAMALIST', self.drama_list);
            self.filterDramaList();
          });
      } catch (e) {
        console.log(e);
      }
    },
    fetchTelefilemList({ commit }, { self }) {
      try {
        axios
          .get(
            `${rtmKlikDomain}/content?idSchema=2003&sort=-dateAvailability&idApp=1`
          )
          .then(function(response) {
            self.telefilem_list = response.data;
            commit('FETCH_TELEFILEMLIST', self.telefilem_list);
            self.filterTelefilemList();
          });
      } catch (e) {
        console.log(e);
      }
    },
    fetchPopularList({ commit }, { self }) {
      try {
        axios
          .get(
            `${rtmKlikDomain}/content?idSchemas=2003,2004,2005,2007,2009&limit=10&include=viewCount&sort=-viewCount&viewPeriod=2&viewPeriodType=day&fields=title,slug,data.image,data.categories,data.classification&sort=-dateAvailability&idApp=1`
          )
          .then(function(response) {
            self.popular_list = response.data;
            commit('FETCH_POPULARLIST', self.popular_list);

            self.filterPopularList();
          });
      } catch (e) {
        console.log(e);
      }
    },
    fetchRTMTVList({ commit }, { self }) {
      try {
        axios
          .get(
            `${rtmKlikDomain}/content?idSchemas=2001&sort=dateAvailability&idApp=1`
          )
          .then(function(response) {
            self.tv_list = response.data;
            commit('FETCH_TVLIST', self.tv_list);

            self.filterTVList();
          });
      } catch (e) {
        console.log(e);
      }
    },
    fetchRTMTVFastChannelList({ commit }, { self }) {
      try {
        axios
          .get(
            `${rtmKlikDomain}/content?idSchemas=2018&sort=dateAvailability&idApp=1`
          )
          .then(function(response) {
            self.tv_fast_channel_list = response.data;
            commit('FETCH_TV_FASTCHANNEL_LIST', self.tv_fast_channel_list);

            self.filterTVFastChannelList();
          });
      } catch (e) {
        console.log(e);
      }
    },
    fetchMastheadsFeatured({ commit }, { self }) {
      try {
        axios
          .get(
            `${rtmKlikDomain}/content?idSchemas=2003,2004,2005,2007,2009&isFeatured=1&sort=-dateFeature&limit=6&fields=title,slug,data&idApp=1`
          )
          .then(function(response) {
            self.masthead_featured = response.data;
            commit('FETCH_MASTHEAD_FEATURED', self.masthead_featured);

            self.filterMastheadFeatured();
          });
      } catch (e) {
        console.log(e);
      }
    },
    fetchNewsMastheadsFeatured({ commit }, { self }) {
      try {
        axios
          .get(
            `${rtmKlikDomain}/content?idSchemas=2007&isFeatured=1&sort=-dateAvailability&fields=title,slug,data&limit=12&idApp=1`
          )
          .then(function(response) {
            self.news_masthead_featured = response.data;
            commit('FETCH_NEWS_MASTHEAD_FEATURED', self.news_masthead_featured);

            self.filterNewsMastheadFeatured();
          });
      } catch (e) {
        console.log(e);
      }
    },

    // rtm ends
  },
  modules: {
    auth,
  },
});

export default store;

// get("../../assets/json_dummy/masthead.json")
